module.exports = __webpack_public_path__ + "static/media/kaart_v8.22ac0782.png";